// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38NPx","title":"styles_title__2cQOX"};